import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    ctaButton: 'All good!',
    infoText:
      'We will send you a notification when the first direct debit is performed.',
    title: 'Your mandate has been successfully added!',
  },
  fr: {
    ctaButton: 'C’est tout bon\xA0!',
    infoText:
      'Nous vous enverrons une notification lorsque le premier prélèvement automatique sera traité.',
    title: 'Votre mandat a été ajouté avec succès\xA0!',
  },
});

export default locales;
